import {
  NAVBAR_HEIGHT,
  NAVBAR_INFORMATIONAL_BANNER_HEIGHT,
  NAVBAR_PROMOTIONAL_BANNER_HEIGHT,
} from '#app/components/AppBar/constants.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { useIsMobile } from '#app/hooks/useIsMobile.js';
import { dayjs } from '@contra/date';
import { useMemo } from 'react';

export const useNavbar = ({
  hasExistingBanner = false,
}: {
  hasExistingBanner?: boolean;
}) => {
  const isMobile = useIsMobile();
  const currentUser = useCurrentUser();

  const bannerStart = '2024-05-01';
  const bannerEnd = '2024-05-14';

  const showPromotionalBanner = useMemo(() => {
    const day = dayjs();
    const isIndy = currentUser?.selectedUserType === 'CONTRACTOR';
    const uiFlags = currentUser?.userInterfaceFlags ?? [];

    return (
      !isMobile &&
      isIndy &&
      day.isBefore(bannerEnd) &&
      day.isAfter(bannerStart) &&
      !uiFlags.includes('HIDE_CREATOR_TOOLS_AWARD_BANNER')
    );
  }, [currentUser, isMobile]);

  return {
    navbarHeight: showPromotionalBanner
      ? NAVBAR_HEIGHT + NAVBAR_PROMOTIONAL_BANNER_HEIGHT
      : hasExistingBanner
        ? NAVBAR_HEIGHT + NAVBAR_INFORMATIONAL_BANNER_HEIGHT
        : NAVBAR_HEIGHT,
    showPromotionalBanner,
  };
};
